import { service } from '@ember/service';
import type CompanyConfigurationModel from 'garaje/models/company-configuration';
import ApplicationSerializer from 'garaje/serializers/application';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type { SinglePayload } from 'jsonapi/response';

export default class CompanyConfigurationSerializer extends ApplicationSerializer {
  @service declare featureFlags: FeatureFlagsService;

  serialize(...args: Parameters<ApplicationSerializer['serialize']>): SinglePayload<CompanyConfigurationModel> {
    const payload = <SinglePayload<CompanyConfigurationModel>>super.serialize(...args);

    // The backend doesn't accept this attribute yet for companies outside the rollout.
    if (!this.featureFlags.isEnabled('visitors-no-auto-approvals')) {
      delete payload.data.attributes['admin-approval-bypass-enabled'];
    }

    return payload;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your serializers.
declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'company-configuration': CompanyConfigurationSerializer;
  }
}
